// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"6f29b324","787":"81192f7c","836":"fa746a71"}[chunkId] + ".chunk.js";
};